export default {
  subscribe_to: "Subscribe to",
  company_detail: "Company/self-employed information",
  purchase: "Purchase",
  try_before_you_buy: "Try before you buy",
  rental: "Rental",
  rent: "Rent",
  per: "Per",
  powered_by: "Powered by",
  individual: "Individual",
  company: "Company",
  name: "Name",
  first_name: "First name",
  last_name: "Last name",
  nif: "NIF",
  company_name: "Company name",
  mobile: "Mobile",
  representative_name: "Representative name",
  email: "Email",
  delivery_address: "Delivery Address",
  address_line: "Address line",
  street_name: "Street name",
  country: "Country",
  select_country: "Select country",
  city: "City",
  zip: "Postcode",
  used_saved_address: "Used saved address",
  shipping_details: "Shipping address",
  state: "State",
  select_state: "Select state",
  vat: "Tax ID / VAT Number",
  use_for_billing_address: "Use different address for billing",
  add_billing_address: "Add billing address",
  billing_address: "Billing address",
  next: "Next",
  pay: "Pay",
  enter_payment_details: "Or enter payments details",
  back: "Back to home",
  card: "Card",
  bank_account: "bank account",
  name_on_card: "Name on Card",
  bank_detail: "Bank Detail",
  account_holder_name: "Account Holder Name",
  account_number: "Account Number",
  account: "Account",
  select_account_type: "Select Account type",
  routing_number: "Routing Number",
  select_currency: "Select Currency",
  currency: "Currency",
  confirmation_paragraph1: "By confirming your order, you allow",
  confirmation_paragraph2:
    " to charge your card for this payment and future payments in accordance with their terms and conditions. You can may cancel your contract after the selected duration.",
  day: " Day",
  days: " Days",
  month: " Month",
  months: " Months",
  years: "Years",
  // Unit options for dropdowns
  Months: "Months",
  Years: "Years",
  you_will_pay: "You will pay today ",
  billed_monthly: "Billed Monthly",
  thanks_for_request: "Thank you for your order !",
  rental_option_desc:
    "We love that you have chosen our rental option, we know it is the future.",
  receive_info: "Your request has been sent successfully",
  verification_1:
    "We need you to verify your identity so we can make sure you are a real person.",
  verification_2: "Have your ID card ready",
  verification_3:
    "We will need to verify your ID, so before you start the verification make sure that you have your ID on hand.",
  verification_4: "You will take a selfie",
  verification_5:
    "We will need you to be in a place with good light so that we can verify your identity through a selfie.",
  verification_6: "Verification approval",
  verification_7:
    "It can take up to 24 hours for us to approve your verification as s member of the team will manually check the information.",
  verification_8: "You must be verified for your application to be accepted.",
  back_to_sharpei: "Go back to website",
  verify_self: "You need to verify yourself to ",
  proceed_with_order: "proceed with the order",
  verification_done: "Verification Completed",
  thank_verified:
    "Thank you for getting verified, we will review your verification and let you know.",
  return: "Return",
  delivery_in_days: "Delivery in 3–7 business days",
  after: "After",
  after_months: "you can return the product,",
  increase_payment:
    "keep it or increase the monthly payments according to your needs",
  sent_info:
    "Be sent to your e-mail address where you will be informed whether your application has been accepted or denied. In case of acceptance you will find all the information in the email.",
  for: "for",
  every: "Payment every ",
  months: " months",
  monthly_payment: "Monthly payment",
  combined_financing_offer: "Combined financing offer for all items",
  single_payment: "Single payment",
  verify_identity: "Verify your",
  identity: "Identity",
  verification: "Verification",
  verify_my_identity: "Verify my identity",
  start: "Start ID verification",
  something_wrong: "Something went wrong. Please try again",
  company_information: "Company Information",
  invalid_phone: "Invalid Phone",
  enter_phone: "Please enter your phone",
  enter_valid_phone: "Please enter valid phone",
  enter_email: "Please enter your email",
  country_code: "Country code",
  phone_number: "Phone number",
  subscription: "Subscription",
  buyback: "Buy-back",
  user_information: "Customer Information",
  shipping: "Shipping",
  payment: "Payment",
  payment_details: "Payment details",
  used_saved_card: "Used saved card",
  card_number: "Card number",
  expiration: "Expiration",
  cvc: "CVC",
  save_this_card: "Save this card",
  continue: "Continue",
  billing: "Billing",
  billing_details: "Billing details",
  verify_message_1:
    "We need to verify your identity for this order to be accepted.",
  verify_message_2: "Once you have verified once you wont have to do it again.",
  order_summary: "Order Summary",
  total_without_tax: "Total without tax",
  tax: "Tax",
  shipping: "Shipping",
  total: "Total",
  free: "Free",
  pay_now: "Pay Now",
  final_step_desc:
    "This is the final step, after you touching Pay Now button, the payment will be transaction.",
  any_doubts: "Do you have any doubts about the rental?",
  any_doubts_for_mobile: "Any doubts about the rental?",
  return_item:
    "After this time you may return the item or pay the difference if you want to buy-it-out.",
  previous: "Previous",
  accept:
    "I accept that my data be processed by Sharpei and may be reused for other associated companies, for operational and non-commercial purposes. In accordance with its ",
  terms_conditions: "Terms and conditions",
  and: "and",
  privacy_policy: "Privacy Policy",
  as_well: "As well as the",
  of: "of",
  zero_tax: "0.00",
  street_warning:
    "It is necessary to add the street number for it to be detected automatically.",
  sub_total: "Subtotal",
  tax_included: "TAX included",
  description: "Description",
  choose_date:
    "All orders are sent ASAP, but if you need us to deliver this on a later date please specify.",
  continue_shopping: "Continue Shopping",
  please_wait: `Congratulations your renting has been pre-approved, we are redirecting you to the contract signing page`,
  payment_not_supported: "Payment Method Not Supported",
  not_qualify: "Thank you for your financing application. Your request is currently under review. A member of our team will contact you within 2-3 business days with our decision.",
  grenke_privacy_policy:
    "By using this service, you will be redirected outside the Sharpei domain to an external portal. The data entered will be processed exclusively for the purpose of evaluating the possibility of concluding a contract, in accordance with the GRENKE privacy policy.",
  grenke_privacy_policy_2:
    "The data will not be disclosed to third parties, unless required by law, although GRENKE may rely on data processors such as B2F, Docusign and Sharpei.",
  learn_more: "Learn more",
  grenke_privacy_policy_3: `Any personal data entered in the form will be treated in accordance with GRENKE's privacy policy. Personal data will be processed solely for the purpose of evaluating the possibility of concluding a contract, legitimized by the necessary contractual or pre-contractual performance between the parties.`,
  grenke_privacy_policy_4:
    "GRENKE will not transfer the data to third parties, except by legal obligation. However, it may rely on data processors, such as B2F, Docusign and Sharpei, exclusively for the aforementioned purposes.",
  grenke_privacy_policy_5:
    "You can exercise the rights recognized by current legislation on data protection, such as access, rectification, deletion, limitation, opposition or portability, by writing to dataprotectionGR@grenke.es.",
  renting: "Renting",
  insurance_desc:
    "Renting offers you the flexibility to use the equipment you need without the upfront cost of ownership. With our plans, you get a lease that includes insurance for added peace of mind. The minimum commitment period aligns with the duration you've selected, making it simple and convenient.",
  advantages: "Advantages",
  fully_comprehensive: "Fully inclusive insurance",
  vat_deduct: "100% VAT deductible",
  benefits: "Financial ease & tax benefits",
  amount_price:
    "The amounts are expressed excluding VAT. Comprehensive insurance is included, with its cost displayed at the final stage of the contract.",
  more_information: "For more information",
  click_here: "click here",
  grenke_consent:
    "I have read and accept that my data is processed following the privacy policy of SHARPEI and GRENKE",
  grenke_self_employed_message:
    "For self-employed individuals, leasing is available for up to 24 months. Prices are indicative and may be adjusted for transactions from €5,000.",
  grenke_company_message:
    "Prices are indicative and may be adjusted for transactions from €10,000.",
  view_policy: "View policy",
  // Grenke document upload page
  grenke_document_upload_title: "Document Upload Required",
  grenke_document_upload_subtitle: "Please upload the required documents to complete your application.",
  grenke_financing_details: "Financing Details",
  grenke_monthly_payment: "Monthly Payment",
  grenke_duration: "Duration",
  grenke_months: "months",
  grenke_initial_payment: "Initial Payment",
  grenke_required_documents: "Required Documents",
  grenke_upload_description: "Please upload the following documents to proceed with your application.",
  grenke_max_file_size: "Maximum file size: 10MB",
  optional: "Optional",
  upload_success: "Upload Successful",
  document_uploaded_successfully: "Document '{doc}' uploaded successfully",
  upload_error: "Upload Error",
  document_upload_failed: "Failed to upload document '{doc}'. Please try again.",
  remove: "Remove",
  submit_documents: "Submit Documents",
  missing_documents: "Missing Documents",
  please_upload_all_required_documents: "Please upload all required documents before submitting.",
  submission_success: "Submission Successful",
  all_documents_submitted_successfully: "All documents have been submitted successfully.",
  submission_error: "Submission Error",
  failed_to_submit_documents: "Failed to submit documents. Please try again.",
  missing_request_token: "Missing request token. Please try again.",
  uploading: "Uploading",
  loading_documents: "Loading documents",
  // Grenke installment summary
  grenke_application_approved: "Application Received !",
  grenke_installment_approved_message: "Your Grenke financing application has been approved. Please review your installment plan below.",
  grenke_month: "month",
  grenke_request_info: "Request Information",
  grenke_request_status: "Request Status",
  grenke_financing_id: "Financing ID",
  continue_to_document_upload: "Continue to Document Upload",
  how_data_process: "How will my data be processed?",
  summary_of_application: "Summary of your application",
  discount: "Discount",
  monthly_rent: "Monthly payment",
  extras_single_payment: "Extras - Single payment",
  insurance_single_payment: "Insurance - Single payment",
  taxes: "Taxes",
  total_with_insurance: "Initial Cost with Full Coverage",
  transaction_over_price_limit: "Thank you for your request",
  transaction_over_price_limit_message:
    "The amount of your request exceeds the credit limit that can be processed online. We will contact you to complete your request.",
  transaction_under_price_limit_message:
    "Thank you for your request. Your request amount is below the €500 credit limit that can be processed online.",
  unknown_error: "Unknown error",
  try_again_later: "Please try again later.",
  preappoval_not_accepted: "Application Under Review",
  wrong_zip_code: "Wrong Zip Code",
  enter_valid_zip_code: "Please enter a valid zip code",
  invalid_us_zip: "Please enter a valid US ZIP code",
  zip_state_mismatch: "ZIP code doesn't match selected state",
  income_warning_too_low: "This seems low. US minimum wage is ~$1,250/month. Please verify this is correct.",
  income_warning_too_high: "This monthly income seems very high. Please verify this is correct.",
  net_income_warning_too_low: "This take-home pay seems low. Please verify this is correct.",
  net_income_exceeds_gross: "Take-home pay cannot be higher than gross income.",
  income_ratio_warning_low_tax: "Your tax rate seems very low. Typical rates are 15-35%. Please verify both amounts.",
  income_ratio_warning_high_tax: "Your tax rate seems very high. Typical rates are 15-35%. Please verify both amounts.",
  enter_valid_fiscal_code: "Please enter a valid VAT number",
  wrong_fiscal_code: "Wrong VAT number",
  grenke_individual_nif_warning: "This service is only for companies and self-employed. If you are not self-employed, your application will not be accepted",
  important: "Important",
  confirm_autonomo: "Confirmation",
  nif_detected_confirm: "You have entered a personal ID (DNI). Please confirm that you are self-employed.",
  yes_im_autonomo: "Yes, I am self-employed",
  no_im_not_autonomo: "No, I am not self-employed",
  grenke_service_not_for_individuals: "This service does not apply to individuals",
  grenke_payment_method: "Grenke payment method",
  purchase_option: "Purchase option at the end of the lease.",
  info_about_renting: "Info about renting",
  verify_message_1:
    "We need to verify your identity for this order to be accepted.",
  verify_message_2: "Once you have verified once you wont have to do it again.",
  verification_1:
    "We need you to verify your identity so we can make sure you are a real person.",
  verification_2: "Have your ID card ready",
  verification_3:
    "We will need to verify your ID, so before you start the verification make sure that you have your ID on hand.",
  verification_4: "You will take a selfie",
  verification_5:
    "We will need you to be in a place with good light so that we can verify your identity through a selfie.",
  verification_6: "Verification approval",
  verification_7:
    "It can take up to 24 hours for us to approve your verification as s member of the team will manually check the information.",
  verification_8: "You must be verified for your application to be accepted.",
  "Equip your company in one click": "Equip your company in one click",
  "Equip your business":
    "Equip your business without compromising your liquidity and pay comfortably in fixed monthly installments.",
  "Only for companies and self-employed":
    "Only for companies and self-employed",
  "How does it work": "How does it work?",
  "Choose the products": "Choose the product/s",
  "Choose the products you want to rent":
    "Choose the products you want to rent.",
  "Select the term and fee": "Select the term and fee",
  "Select the terms that best suits you":
    "Between 12 and 48 months, select the term that best suits your needs.",
  "Perform online verification": "Perform online verification",
  "Complete the information":
    "Complete your information, sign the contract online and wait for the approval email.",
  "Receive your products": "Receive your products",
  "Enjoy products":
    "Receive your products and enjoy them for the time you have contracted them.",
  "Return it, buy it or extend your contract":
    "Return it, buy it or extend your contract",
  "When contract ends":
    "When the contract ends you will be able to choose what to do, if you return the product, if you buy it or if you extend your contract.",
  "Welcome to the circular economy": "Welcome to the circular economy!",
  "Good for you, good for the planet": "Good for you, good for the planet.",
  application_submitted: "The application has been processed correctly",
  request_processed: "The request has been processed correctly,",
  receive_email_shortly:
    "you should be receiving an email with more information about the order shortly.",
  return_to_portal: "Return to the portal",
  email_required: "Email is required.",
  name_require: "Name is required",
  company_name_required: "Company Name is required",
  address_required: "Address is required",
  city_required: "City is required",
  state_required: "State is required",
  country_required: "Country is required",
  zip_required: "Zip code is required",
  billing: "Billing",
  enter_address: "Enter your address",
  enter_phone_number: "Enter a phone number",
  invalid_email: "Invalid email",
  phone_number_required: "Phone number is required",
  invalid_phone: "Invalid phone number",
  first_name_required: "First name is required",
  last_name_required: "Last name is required",
  nif_required: "NIF is required",
  representative_name_required: "Representative Name is required",
  representative_name_two_surnames_required: "Representative name must include first name and two surnames (format: FirstName Surname1 Surname2)",
  submit: "Submit",
  stripe_payment_method: "Stripe Payment Method",
  valid_nif: "NIF must be 9 alphanumeric characters",
  calculating: "Calculating",
  user_detail: "Customer information",
  "Get equipped comfortably":
    "Get equipped by comfortably paying your fixed monthly installments.",
  "Select the terms that best suits you b2c":
    "Select the term that best suits your needs.",
  "Complete the information b2c":
    "Complete your details and verify your identity at the end of the order.",
  "Information for companies/self-employed workers":
    "Information for companies/self-employed workers",
  "Get your product in one click": "Get your product in one click",
  // Financing related translations
  additional_information: "Additional Information",
  ssn: "Social Security Number",
  ssn_required: "SSN is required",
  invalid_ssn: "Please enter a valid 9-digit SSN",
  invalid_drivers_license: "Please enter a valid Driver’s License number",
  invalid_drivers_license_basic: "Driver’s License must be 4-20 alphanumeric characters (letters and numbers only)",
  invalid_drivers_license_fake: "This appears to be a fake or test license number. Please enter a real license number",
  invalid_drivers_license_format: "Driver’s License format is invalid for the selected state",
  invalid_drivers_license_state_format: "Driver’s License format doesn't match the expected format for your state",
  invalid_passport_format: "US Passport must be exactly 9 alphanumeric characters",
  invalid_state_id_format: "State ID must be 4-20 alphanumeric characters",
  state_required_for_license: "State is required when using a Driver’s License",
  drivers_license_predefined_note: "Driver’s License is pre-selected as it's currently the only accepted form of ID",
  select_state_first: "Select your state first",
  tooltip_state_selection: "Select your state to enable proper license format validation",
  tooltip_select_state_first: "Please select your state first for proper validation",
  date_of_birth: "Date of Birth",
  dob_required: "Date of birth is required",
  dob_future: "Date of birth cannot be in the future",
  invalid_dob: "Invalid date format",
  must_be_18_years_or_older: "You must be 18 years or older",
  gross_income: "Gross Income",
  gross_income_required: "Gross income is required",
  net_income: "Net Income",
  net_income_required: "Net income is required",
  income_positive: "Income must be a positive number",
  pay_frequency: "Pay Frequency",
  pay_frequency_required: "Pay frequency is required",
  invalid_pay_frequency: "Please select a valid pay frequency",
  select_pay_frequency: "Select pay frequency",
  last_pay_day: "Last Pay Day",
  last_pay_day_required: "Last pay day is required",
  last_pay_day_future: "Last pay day cannot be in the future",
  next_pay_day: "Next Pay Day",
  next_pay_day_required: "Next pay day is required",
  next_pay_day_before_last: "Next pay day must be after last pay day",
  best_estimate: "Best Estimate",
  best_estimate_required: "Best estimate is required",
  estimate_positive: "Estimate must be a positive number",
  enter_first_name: "Enter your first name",
  enter_last_name: "Enter your last name",
  enter_email: "Enter your email",
  enter_phone_number: "Enter your phone number",
  enter_address: "Enter your address",
  enter_city: "Enter your city",
  enter_state: "Enter your state",
  enter_zip: "Enter your zip code",
  back_to_product: "Back to Product",
  select_customer_type: "Select customer type",
  duration: "Duration",
  finalized_offer_terms: "Finalized offer terms",
  quantity: "Quantity",
  leasing_total: "Leasing total",
  purchase_option_at_end_of_lease: "Purchase option at end of lease",
  consumables: "Consumables",
  monthly_lease: "Monthly lease",
  first_month: "First Month",
  monthly_financing: "Monthly financing",
  enter_discount_code: "Enter discount code",
  apply: "Apply",
  enter_contact_person_name: "Enter representative name",
  enter_tax_id_vat_number: "Enter Tax ID / VAT Number",
  invalid_spanish_tax_id: "Invalid Spanish NIF/CIF/NIE format",
  spanish_tax_id_9_chars: "Spanish tax ID must be 9 characters",
  invalid_spanish_tax_id_format: "Invalid format. Must be: CIF (Letter+7digits+Letter/Digit), NIF (8digits+Letter), or NIE (X/Y/Z+7digits+Letter)",
  standard_sharpei_terms:
    "Standard Sharpei Terms and Conditions apply to this purchase. By using our platform, you agree to these terms.",
  terms_govern_use:
    "These terms and conditions govern your use of the Sharpei platform and its services.",
  terms_acknowledgment:
    "By continuing to use Sharpei's services, you acknowledge that you have read, understood, and agree to these terms.",
  close: "Close",
  sharpei_privacy_policy: "Sharpei Privacy Policy",
  sharpei_privacy_policy_description:
    "Sharpei's Privacy Policy describes how we collect and use your personal information through our platform.",
  sharpei_privacy_policy_commitment:
    "We are committed to protecting your privacy and ensuring the security of your personal information.",
  sharpei_privacy_policy_explanation:
    "This policy explains how we collect, use, and disclose your information when you use our platform.",
  grenke_privacy_policy_header: "Grenke Privacy Policy",
  standard_purchase:
    "Standard Terms and Conditions apply to your purchase from",
  terms_purchase:
    "By proceeding with your purchase, you agree to abide by these terms and conditions.",
  standard_privacy:
    "Standard Privacy Policy applies to your personal information collected by ",
  your_privacy:
    "Your privacy is important to us. This policy describes how we collect and process your personal information.",
  the_merchant: "the merchant",
  powered_by_sharpei: "Powered by Sharpei",
  mo: "mo",
  add: "Add",
  delivery: "Delivery",
  consumables_total: "Consumables total",
  includes_all_services: "Includes device lease and all subscriptions",
  tax_id_required: "Tax ID is required",
  // Leasing Modal Translations
  smart_equipment_leasing: "Smart Equipment Leasing",
  leasing_subtitle:
    "Get the latest technology while preserving capital with our flexible business leasing solutions",
  how_it_works: "How it works",
  choose_your_products: "Choose your products",
  choose_products_desc:
    "Select your product and customize it with optional services or consumables.",
  select_your_term: "Select your term",
  select_term_desc:
    "Choose a lease term from 12 to 60 months that aligns with your business planning",
  quick_approval: "Quick approval process",
  quick_approval_desc:
    "Simple business verification with fast approval for registered companies",
  flexible_options: "Flexible end-of-term options",
  flexible_options_desc:
    "At the end of your lease, buy it, upgrade it, or return it - your call.",
  why_choose_business: "Why choose business leasing?",
  optimize_cash_flow: "Optimize cash flow",
  tax_efficient: "Tax-efficient solution",
  custom_payment: "Custom payment terms",
  regular_upgrades: "Regular upgrades",
  reduce_reuse: "Reduce, Reuse, Recycle",
  circular_economy: "Hello Circular Economy",
  own_less: "Own Less Things",
  experience_more: "Experience More",
  // Individual Leasing Modal
  lease_love_upgrade: "Lease It. Love It. Upgrade It.",
  individual_leasing_subtitle:
    "Access the technology you need with affordable monthly payments and full flexibility",
  why_choose_personal: "Why choose personal leasing?",
  zero_upfront: "Zero upfront cost",
  low_monthly: "Low monthly payments",
  always_updated: "Always up to date",
  no_commitment: "No long-term commitment",
  // Individual-specific step descriptions
  how_it_works_individual: "How it works for you",
  choose_your_products_individual: "Choose what you need",
  choose_products_desc_individual:
    "Browse and select products that fit your lifestyle and budget.",
  select_your_term_individual: "Pick your timeline",
  select_term_desc_individual:
    "Choose a lease term from 12 to 60 months that works with your personal needs and budget",
  quick_approval_individual: "Quick personal approval",
  quick_approval_desc_individual:
    "Simple identity verification with fast approval for individuals",
  flexible_options_individual: "Flexible end options",
  flexible_options_desc_individual:
    "When your lease ends, buy it, upgrade to something new, or return it - completely your choice.",
  enter_company_name: "Enter company name",
  business_type: "Business Type",
  select_business_type: "Select your business type",
  autonomo: "Self-Employed / Sole Trader",
  empresa: "Company / Registered Business",
  your_full_name: "Your Full Name",
  authorized_contact_person: "Authorized Contact Person",
  
  // Grenke eligibility requirements
  grenke_b2b_only: "This service is only available for businesses and self-employed individuals.",
  grenke_autonomo_requirements_title: "Requirements for Self-Employed:",
  grenke_autonomo_min_years: "Minimum 3 years of operation as self-employed",
  grenke_autonomo_max_term: "Maximum term: 24 months (standard operations)",
  grenke_autonomo_extended_term: "Up to 60 months available for operations > €5,000 or in Canary Islands",
  grenke_empresa_requirements_title: "Requirements for Companies:",
  grenke_empresa_min_years: "Minimum 1 full year of operation",
  grenke_empresa_max_term: "Maximum term: 60 months",
  
  // Business establishment date
  fecha_de_alta: "Business Start Date",
  fecha_de_alta_placeholder: "Select date",
  fecha_de_alta_required: "Business start date is required",
  fecha_de_alta_invalid: "Invalid date",
  autonomo_min_3_years: "Self-employed must have minimum 3 years of operation",
  empresa_min_1_year: "Companies must have minimum 1 year of operation",
  fecha_de_alta_help: "Date when you started your self-employed or business activity",
  fecha_cannot_be_future: "Date cannot be in the future",
  autonomo_must_use_nif_nie: "Self-employed must use NIF (DNI) or NIE. Format: 8 digits + letter (e.g., 12345678A) or X/Y/Z + 7 digits + letter (e.g., X1234567A)",
  empresa_must_use_cif: "Companies must use CIF. Format: Letter + 7 digits + letter/digit (e.g., B12345678)",
  unit: "Unit",
  units: "Units",
  application_error: "Application Error",
  processing_error: "Processing Error",
  tooltip_company_name: "Legal registered name of your company",
  tooltip_representative_name: "Full name of authorized company representative",
  tooltip_vat: "Company tax ID or VAT number",
  
  // US Manual Payment Integration translations
  ein_fed_tax_id: "EIN or Fed Tax ID #",
  annual_revenue: "Annual Revenue",
  business_owner_ssn: "Social Security Number",
  
  // Placeholders
  enter_ein_fed_tax_id: "Enter EIN or Fed Tax ID",
  select_annual_revenue_range: "Select annual revenue range",
  enter_business_owner_ssn: "Enter SSN",
  
  // Tooltips
  tooltip_ein_fed_tax_id: "Employer Identification Number or Federal Tax ID",
  tooltip_annual_revenue: "Select the company's annual revenue range",
  tooltip_business_owner_ssn: "Business owner's Social Security Number",
  
  // Validation messages
  ein_fed_tax_id_required: "EIN or Fed Tax ID is required",
  annual_revenue_required: "Annual revenue is required",
  business_owner_ssn_required: "Business owner SSN is required",
  tooltip_first_name: "Your first name",
  tooltip_last_name: "Your last name",
  tooltip_email: "Email address for order confirmations",
  tooltip_phone: "Phone number with country code",
  tooltip_street: "Street address with house/building number",
  tooltip_city: "City or town name",
  tooltip_state: "State, province, or region",
  tooltip_country: "Country of shipping address",
  tooltip_zip: "ZIP or postal code",
  tooltip_billing_street: "Billing street address",
  tooltip_billing_city: "City for billing address",
  tooltip_billing_state: "State for billing address",
  tooltip_billing_country: "Country for billing address",
  tooltip_billing_zip: "ZIP code for billing address",
  tooltip_ssn: "9-digit Social Security Number in XXX-XX-XXXX format.",
  tooltip_pay_frequency: "How often you receive your paycheck",
  tooltip_gross_income: "Income before taxes and deductions",
  tooltip_net_income: "Take-home pay after taxes",
  tooltip_last_pay_day: "Date of your most recent paycheck",
  tooltip_next_pay_day: "Date of your next expected paycheck",
  tooltip_dob_age_restriction: "You must be over 18 for this service",
  enter_billing_address: "Enter billing address",
  go_back: "Go back",
  continue_shopping: "Continue Shopping",
  try_different_payment: "Try different payment method",
  read_only: "Read only",
  // Add new translation keys for price status indicators
  provisional_price: "Provisional Price",
  final_price: "Final Price",
  price_may_change_based_on_credit_check:
    "This price is provisional and may change based on your credit check results",
  price_confirmed_after_credit_check:
    "This price has been finalized after your credit check",
  price_confirmed_for_x_months:
    "This price has been finalized for {count} monthly payments",
  financing_pricing_explanation:
    "The monthly payment displayed is currently provisional. The final monthly payment will be determined after your credit check is complete.",
  partial_approval_message:
    "Your cart total is {invoiceAmount} and your approval amount is {approvalAmount}. Are you sure you want to pay the upfront amount of {upfrontAmount}?",
  today: "today",

  // Financing application error messages
  unable_to_process_application: "We're Unable to Process Your Application",
  generic_rejection_message:
    "We're sorry, but we're unable to approve your financing application at this time. This may be due to various factors including credit history, income verification, or current lending criteria. Don't worry - you still have other payment options available to complete your purchase.",

  // Additional financing related messages
  financing_declined: "Financing Application Declined",
  financing_expired: "Application Has Expired",
  application_flagged: "Application Under Review",
  application_cancelled: "Application Cancelled",
  no_lender_available: "No Financing Options Available",
  application_processing_timeout:
    "We're experiencing some technical difficulties processing your application right now. This is usually temporary - please try again in a few minutes.",
  decline_message:
    "We understand this may be disappointing. Our lending partners have carefully reviewed your application, but we're unable to offer financing at this time. This decision is based on their current lending criteria and doesn't reflect on you personally.",
  expired_message:
    "Your application session has expired for security reasons. This usually happens when an application isn't completed within the required timeframe. You can start a new application if you'd like to try again.",
  fraud_message:
    "For your security and ours, we need to take an extra look at your application. This is a standard security measure and doesn't mean anything is wrong. Please contact our customer support team, and we'll help verify your information quickly.",

  // Credit check disclaimer messages
  checking_eligibility_wont_affect_credit: "Checking your eligibility won't affect your credit",
  soft_credit_check_no_impact: "Soft credit check only • No impact on credit score",

  // Summary section labels
  monthly_commitment: "Monthly Commitment",
  you_will_pay_today: "You will pay today",
  total_today: "Total today",
  changemind_message:
    "No problem at all - your application has been cancelled as requested. You can always start a new application later if you change your mind.",
  no_lender_message:
    "Unfortunately, we don't currently have financing partners available for this particular purchase. The good news is that you can still complete your order using a credit card or other payment method.",
  weekly_payment: "Weekly payment",
  week: "week",
  weeks: "weeks",
  term_length: "Term Length",
  // New keys for financing vs leasing
  financing: "Financing",
  leasing: "Leasing",
  financing_summary: "Financing Summary",
  leasing_summary: "Leasing Summary",
  // Missing translation keys
  something_went_wrong: "Something went wrong",
  generic_error: "An error occurred. Please try again.",
  "Pre-Loved": "Pre-Loved",
  "Save": "Save",
  "Certified refurbished with same quality guarantee": "Certified refurbished with same quality guarantee",
  purchase_option_at_end_of_financing: "Purchase option at the end of lease",
  monthly_financing: "Monthly financing",
  info_about_financing: "Info about financing",
  info_about_leasing: "Info about leasing",
  learn_more_about_business_financing: "Learn more about business financing",
  learn_more_about_business_leasing: "Learn more about business leasing",
  fixed_term: "Fixed term",
  upfront_payment: "Upfront payment",
  upfront_payment_explanation: "Once your financing offer is approved, you'll be asked to make an upfront payment. This is a one-time amount you pay at the start of your agreement. It helps confirm your commitment and is part of the total cost — not an extra fee. You'll only see the payment page after your offer has been accepted by the financing provider.",
  due_today: "Due today",
  select_upfront_payment: "Select upfront payment",
  delete_item: "Delete item",
  deleting_item: "Deleting item...",
  financing_amount: "Financing amount",
  upfront_payment_required: "Upfront payment required",
  complete_upfront_payment_to_finalize:
    "Complete upfront payment to finalize financing",
  financing_approved: "Financing approved",
  payment_breakdown: "Payment breakdown",
  total_order_value: "Total order value",
  secure_payment_notice: "Secure payment notice",
  via_financing_provider: "Via financing provider",
  submitting: "Submitting",
  complete: "Complete",
  your_leasing_offer: "Your leasing offer",
  your_financing_offer: "Your financing offer",
  please_provide_banking_info: "Please provide banking info",
  complete_your: "Complete your",
  thanks_for_your_application: "Thanks for your application",
  you_will_hear_from_us_very_soon: "You will hear from us very soon",
  financing_details: "Financing Details",
  payment_amount: "Payment Amount",
  payment_frequency: "Frequency",
  number_of_payments: "Number of Payments",
  total_price: "Total Price",
  first_payment_date: "First Payment Date",
  lender: "Lender",
  loading_offer_details: "Loading offer details...",

  // Additional financing fields
  residential_information: "Residential Information",
  employment_information: "Employment Information",
  
  // Type of Residency
  type_of_residency: "Type of Residency",
  type_of_residency_required: "Type of residency is required",
  select_residency_type: "Select residency type",
  
  // Time at Current Residence
  time_at_current_residence: "Time at Current Residence",
  time_at_current_residence_required: "Time at current residence is required",
  
  // Housing Type
  housing_type: "Housing Type",
  housing_type_required: "Housing type is required",
  select_housing_type: "Select housing type",
  
  // Employment Type
  employment_type: "Employment Type",
  employment_type_required: "Employment type is required",
  select_employment_type: "Select employment type",
  
  // Employment Name
  employment_name: "Employment/Company Name",
  employment_name_required: "Employment name is required",
  
  // Job Title
  job_title: "Job Title",
  job_title_required: "Job title is required",
  
  // Experience
  experience: "Experience",
  experience_required: "Experience is required",
  
  // Document validation messages
  document_type_required: "Document type is required",
  document_number_required: "Document number is required",
  identification_expiration_date_required: "Identification expiration date is required",
  identification_issued_date_required: "Identification issued date is required",
  resident_since_required: "Resident since date is required",
  card_expiration_required: "Card expiration date is required",
  uscis_number_required: "USCIS number is required",
  
  // Validation error messages
  expiration_date_not_before_today: "Expiration date cannot be before today",
  issued_date_not_after_today: "Issued date cannot be after today",
  invalid_gross_income: "Invalid gross income format",
  invalid_net_income: "Invalid net income format",
  invalid_last_pay_day: "Invalid last pay day format",
  invalid_next_pay_day: "Invalid next pay day format",
  years_positive: "Years must be a positive number",
  years_must_be_number: "Years must be a number",
  
  // Document specific fields
  document_number: "Document Number",
  identification_expiration_date: "Identification Expiration Date",
  identification_issued_date: "Identification Issued Date",
  identification_information: "Identification Information",
  resident_since: "Resident Since",
  card_expiration: "Card Expiration",
  uscis_number: "USCIS Number",
  
  // Document type options are already translated as they're in English
  
  // Tooltip texts for new fields
  tooltip_document_number: "Enter your document number as shown on your ID",
  tooltip_resident_since: "Date since you became a US resident",
  tooltip_card_expiration: "Expiration date on your alien registration card",
  tooltip_uscis_number: "Your USCIS registration number",
  
  // Error handling for specific conditions
  error_calculating_taxes: "Error calculating taxes",
  error: "Error",
  
  // Additional validation messages for time/experience fields
  time_unit_required: "Time unit is required",
  experience_unit_required: "Experience unit is required",
  time_must_be_positive: "Time must be at least 1",
  time_must_be_whole_number: "Time must be a whole number",
  experience_must_be_positive: "Experience must be positive",
  experience_must_be_whole_number: "Experience must be a whole number",
  includes_device_lease_and_subscriptions:
    "Includes device lease and subscriptions",
  // TerraceFinance related translations
  residential_information: "Residential Information",
  type_of_residence: "Type of Residence",
  select_residence_type: "Select residence type",
  years_at_residence: "Years at Current Residence",
  identification_information: "Identification Information",
  document_type: "Document Type",
  passport_country: "Country Where Passport Was Issued",
  select_passport_country: "Select country where passport was issued",
  tooltip_passport_country: "Select the country that issued your passport",
  passport_country_required: "Country where passport was issued is required",
  select_document_type: "Select document type",
  document_number: "Document Number",
  identification_expiration_date: "Identification Expiration Date",
  identification_issued_date: "Identification Issued Date",
  resident_since: "Resident Since",
  card_expiration: "Card Expiration",
  uscis_number: "USCIS Number",

  
  // Validation messages
  document_type_required: "Document type is required",
  document_number_required: "Document number is required",
  identification_expiration_date_required: "Identification expiration date is required",
  identification_issued_date_required: "Identification issued date is required",
  type_of_residence_required: "Type of residence is required",
  years_at_residence_required: "Years at residence is required",
  manufacturer_name_required: "Manufacturer name is required",
  model_required: "Model is required",
  condition_required: "Condition is required",
  resident_since_required: "Resident since date is required",
  card_expiration_required: "Card expiration date is required",
  uscis_number_required: "USCIS number is required",
  expiration_date_not_before_today: "Expiration date cannot be before today",
  issued_date_not_after_today: "Issued date cannot be after today",
  invalid_gross_income: "Gross income must be a positive number",
  invalid_net_income: "Net income must be a positive number",

  // Tooltips
  tooltip_document_type: "Driver’s License is currently the only accepted form of identification",
  tooltip_document_number: "Enter your Driver’s License number (4-20 alphanumeric characters). Examples: A1234567 (CA), 12345678 (TX), F123456789012 (FL)",
  tooltip_identification_expiration: "When your ID document expires",
  tooltip_identification_issued: "When your ID document was issued",
  tooltip_type_of_residence: "Your current living situation",
  tooltip_years_at_residence: "How long you've lived at current address",
  tooltip_manufacturer_name: "Name of the product manufacturer",
  tooltip_model: "Product model name/number",
  tooltip_condition: "Current condition of the product",
  tooltip_resident_since: "When you became a resident",
  tooltip_card_expiration: "When your card expires",
  tooltip_uscis_number: "Your USCIS registration number",
  years_must_be_number: "Years must be a valid number",

  // Enhanced form field labels
  authorized_contact_person: "Authorized Contact Person",
  business_tax_id: "Business Tax ID / VAT Number",
  housing_ownership: "Do you own or rent your home?",
  dwelling_type: "What type of dwelling do you live in?",
  how_long_current_address: "How long have you lived at your current address?",
  employment_status: "What is your employment status?",
  employer_or_income_source: "Employer or Income Source Name",
  job_title_or_position: "Job Title or Position",
  time_at_current_job: "How long in current role?",
  monthly_income_before_taxes: "Monthly Income (Before Taxes)",
  monthly_take_home_pay: "Monthly Take-Home Pay (After Taxes)",
  how_often_paid: "How often are you paid?",
  date_of_most_recent_paycheck: "Date of Your Most Recent Paycheck",
  date_of_next_expected_paycheck: "Date of Your Next Expected Paycheck",
  government_id_type: "Type of government-issued ID?",

  // Enhanced tooltip translations
  tooltip_authorized_contact: "The full name of the person authorized to make decisions and sign documents for this company",
  tooltip_business_tax_id: "Your company's official tax identification number (EIN in US, VAT number in EU, etc.)",
  tooltip_housing_ownership: "Select whether you own your home, rent it, or have another arrangement (e.g., living with family)",
  tooltip_dwelling_type: "Select the type of building or dwelling you live in (apartment, house, suite, etc.)",
  tooltip_time_at_current_address: "Enter how long you have been living at your current address",
  tooltip_time_unit: "Select whether to count in months or years",
  tooltip_employment_status: "Select your current work situation: Employed (work for a company), Self employed (own business), or Benefit (receiving government benefits)",
  tooltip_employer_income_source: "Enter your employer name, business name, or source of income (e.g., company name, 'Social Security', 'Unemployment')",
  tooltip_job_title: "Enter your job title, position, or role (e.g., Manager, Sales Associate, Teacher, Self-Employed)",
  tooltip_experience_time: "Enter how long you have been in your current job or receiving your current income",

  // ✅ NEW: Rent/Mortgage translations
  monthly_rent_mortgage: "Monthly Rent/Mortgage Payment",
  monthly_rent_mortgage_required: "Monthly rent/mortgage payment is required",

  // ✅ NEW: Rent/Mortgage tooltip
  tooltip_rent_mortgage: "Enter your monthly rent or mortgage payment amount",
  
  // ✅ NEW: ID State of Issuance translations
  id_state_of_issuance: "State",
  id_state_of_issuance_required: "State where ID was issued is required",
  select_id_state: "State where ID was issued",
  tooltip_id_state_selection: "Select the state where your ID document was issued (may be different from your current address)",

  // ✅ NEW: Citizenship Status translations
  citizenship_status: "Citizenship Status",
  citizenship_status_required: "Citizenship status is required",
  select_citizenship_status: "Select your citizenship status",
  tooltip_citizenship_status: "Select your current citizenship or residency status in the United States",

  // Cart operation messages
  success: "Success",
  removed_from_cart: "removed from cart",
  cart_updated: "Cart updated successfully",
  product_removed_from_cart: "Product removed from cart",
  deleting_item: "Removing item...",
  delete_item: "Remove item",
  total_cost: "Total cost",
  'Loading cart data': "Loading cart data",
  select_date: "Please select date",
  hide_details: "Hide details",
  order_Summary: "Order Summary",
  
  // Cart discount translations
  cart_discount_applied: "Cart Discount Applied!",
  discount_applied_to_cart: "discount applied to your cart",
  item_discount_applied: "Item Discount Applied!",
  discount_applied_to_item: "discount applied to this item",
  qty: "Qty",
  est: "Est",
  down_payment: "down payment",
  learn_more_about_financing: "Learn more about financing",
  financing_desclaimer: "*Actual terms may vary based on credit approval and available rates at the time of application. Not all applicants will qualify.",
  order_submitted: "Order Submitted",
  canary_islands_manual_review: "Your order has been submitted for review. Orders to the Canary Islands require additional verification. We'll be in touch within the next 24 hours.",
  manual_review_info: "Our team will review your order and contact you within 1 business day to finalize the details.",
  manual_review_timeline: "Processing typically takes 24 hours during business days.",
  order_id: "Order ID",
  questions_contact: "If you have any questions, please contact us at",
  autonomus_community: "Autonomous Community",
  
  // Manual processing translations
  order_received: "Thank you for your order!",
  manual_processing_message: "We have received your order and were reviewing your application. You will receive an email shortly with the acceptance or rejection of your application.",
  order_number: "Order Number",
  manual_processing_contact: "If you have any questions about your order, please contact our customer service team.",
  b2b_renting_contact_title: "Questions about B2B Renting?",
  b2b_renting_contact_message: "If you have any doubts or questions regarding the B2B Renting service, please call",
  b2b_renting_phone: "+34678438486",
  total_monthly_commitment: "Total monthly commitment",
  sales_tax: "Sales Tax",
  checkout_already_used: "Checkout Already Used",
  checkout_already_used_message: "This checkout session has already been used or completed. Please start a new checkout to continue.",
  tax_id_vat_number: "Enter Tax ID / VAT Number",
  companyName: "Company name"
};
